<template>
    <uploadList :limit="11" uploadSize="2gb" :accept="['.mp4','.mov']"></uploadList>
</template>
<script>
import uploadList from '../../components/uploadList/index.vue'
export default {
    name: 'Video',
    data() {
        return {
            videoList: [
                
            ]
        }
    },
    components: {
        uploadList
    }
}
</script>
<style lang="less" scoped>

</style>